import React, { useEffect, useState } from 'react';
import { View, Platform, TouchableHighlight } from 'react-native';

import _ from 'lodash';
import { PropTypes } from 'prop-types';

import { VFText, VFInput, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import images from '../../../Themes/Modes/Light/Images';

import styles from './VoucherTopUp.Styles.js';

const VoucherTopUp = ({
  onCodeChanged,
  maxLength,
  iconName,
  theme,
  onCameraPressed,
  tintColor,
  textColor,
  baseColor,
  selectionColor,
  helperTextColor,
  labelTextStyle,
  keyboardType,
  containerStyle,
  textInputContainerStyle,
  setIsValidVoucherTopupNumber,
  regexForInput,
  setVoucherTopupNumber,
  voucherTopupNumber,
}) => {
  const initialSelectColor = selectionColor || theme.colors.textInput.default.selectionColor;
  const contentInset = { label: Platform.OS === 'android' ? 1 : -1 };

  const [customLabel, setLabel] = useState('voucher_top_up_placeHolder');
  const [selectColor, setSelectColor] = useState(initialSelectColor);

  useEffect(() => {
    validateCode(voucherTopupNumber);
  }, [voucherTopupNumber]);

  const validateCode = text => {
    const isMaxLength = text?.length === maxLength;
    const isValid = regexForInput.test(text) && isMaxLength;

    setVoucherTopupNumber(text);
    setIsValidVoucherTopupNumber(isValid);
    setSelectColor(isMaxLength ? theme.colors.backgroundColor : initialSelectColor);

    if (text?.length !== 0) {
      setLabel('voucher_top_up_label');
    }

    _.isFunction(onCodeChanged) && onCodeChanged(text);
  };

  const onCameraBtnPressed = () => {
    _.isFunction(onCameraPressed) && onCameraPressed();
  };

  return (
    <>
      <VFText i18nKey={'voucher_top_up_description'} style={styles.subTitle(theme)} />
      <View style={styles.voucherInputContainer}>
        <VFInput
          label={customLabel}
          fontSize={18}
          value={voucherTopupNumber?.slice(0, maxLength)}
          helperText={'voucher_top_up_helper_text'}
          keyboardType={keyboardType || 'number-pad'}
          labelTextStyle={[styles.label(theme), labelTextStyle]}
          containerStyle={[styles.inputContainerStyle, containerStyle]}
          textInputContainerStyle={[styles.textInputContainerStyle, textInputContainerStyle]}
          contentInset={contentInset}
          baseColor={baseColor || theme.colors.textInput.default.baseColor}
          tintColor={tintColor || theme.colors.textInput.default.tintColor}
          textColor={textColor || theme.colors.textColorThree}
          showHelperText={false}
          helperTextColor={helperTextColor || theme.colors.textInput.default.helperTextColor}
          selectionColor={selectColor}
          onChangeText={validateCode}
          maxLength={maxLength}
          testID={FrameworkTestKeys.VoucherTopupInputText}
          onFocus={() => setLabel('voucher_top_up_label')}
          onBlur={() => {
            if (voucherTopupNumber.length === 0) {
              setLabel('voucher_top_up_placeHolder');
            }
          }}
        />
        <View style={styles.voucherButtonContainer}>
          <TouchableHighlight
            style={styles.iconContainer(theme)}
            onPress={onCameraBtnPressed}
            testID={FrameworkTestKeys.VoucherTopupConfirmButton}
          >
            <Icon name={iconName} type="image" size={34} style={styles.icon} />
          </TouchableHighlight>
        </View>
      </View>
      <View style={styles.fotterContainer} />
    </>
  );
};

VoucherTopUp.defaultProps = {
  iconName: images.ic_voucher_camera_button,
  regexForInput: /^\d+$/,
  maxLength: 15,
};
VoucherTopUp.propTypes = {
  voucherTopupNumber: PropTypes.string,
  maxLength: PropTypes.number,
  iconName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  theme: PropTypes.shape({
    name: PropTypes.string,
    colors: PropTypes.object,
  }),
  setVoucherTopupNumber: PropTypes.func,
  onCodeChanged: PropTypes.func,
  onCameraPressed: PropTypes.func,
  tintColor: PropTypes.string,
  textColor: PropTypes.string,
  baseColor: PropTypes.string,
  selectionColor: PropTypes.string,
  helperTextColor: PropTypes.string,
  labelTextStyle: PropTypes.object,
  keyboardType: PropTypes.string,
  containerStyle: PropTypes.object,
  textInputContainerStyle: PropTypes.object,
  setIsValidVoucherTopupNumber: PropTypes.func,
  regexForInput: PropTypes.string,
};

export default withTheme(VoucherTopUp);
